import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import kk from './locales/kk.json';

const LANG_KEY = 'olso_lang';

export const languages = [
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
  { code: 'kk', label: 'Қазақша' },
] as const;

export type LangCode = 'en' | 'ru' | 'kk';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru }, kk: { translation: kk } },
  lng: (localStorage.getItem(LANG_KEY) as LangCode) || 'ru',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export const setStoredLang = (lang: LangCode) => {
  localStorage.setItem(LANG_KEY, lang);
  i18n.changeLanguage(lang);
};

/** Map i18n lang code to Intl locale for date/number formatting */
export const getDateLocale = (): string => {
  const lang = i18n.language || 'en';
  const map: Record<string, string> = { en: 'en-US', ru: 'ru-RU', kk: 'kk-KZ' };
  return map[lang] || 'en-US';
};

export default i18n;
